import { RootGetters, RootState } from "./types";
import { UserState } from "../user/types";
import { VUEX_ROOT_GETTER_NAMES } from "@tt-app/constants";
import { flattenCourseExercises } from "@tt-app/utils";

const {
  BOOKMARKED_COURSE_LIMIT_MULTIPLIER,
  COURSE_EXPLORE_SEARCH_STRING,
  COURSE_EXPLORE_SELECTED_CATEGORY_IDS,
  COURSE_EXPLORE_SELECTED_EXAM_INDEX,
  COURSE_EXPLORE_SELECTED_LEVEL_INDEXES,
  FLAT_EXERCISE_LIST,
  GROUP_COURSE_LIMIT_MULTIPLIER,
  GROUP_COURSE_SELECTED_CATEGORY_IDS,
  GROUP_COURSE_SELECTED_EXAM_INDEX,
  GROUP_COURSE_SELECTED_GROUP_INDEX,
  GROUP_COURSE_SELECTED_LEVEL_INDEXES,
  OPENED_CHAPTERS,
  LEARNING_HISTORY_END_DATE,
  LEARNING_HISTORY_START_DATE,
  LEARNING_HISTORY_SELECTED_EXERCISE_TYPE_AND_SKILL,
  PREVIOUS_ROUTE,
  SELECTED_SKILL_LEVEL_INDEXES
} = VUEX_ROOT_GETTER_NAMES;

export const rootGetters: RootGetters = {
  can_go_back: state => !!state.navigation.prevPath,

  auth_info: state => {
    const userState = (state as any).user as UserState;
    const { authentication, selectedAlias } = userState;

    const token = authentication.token;
    const alias = selectedAlias;

    return alias && token ? { token, aliasUuid: alias.uuid } : undefined;
  },
  [BOOKMARKED_COURSE_LIMIT_MULTIPLIER](state: RootState) {
    return state.course.bookmarked.limitMultiplier;
  },
  [COURSE_EXPLORE_SEARCH_STRING](state: RootState) {
    return state.course.explore.searchString;
  },
  [COURSE_EXPLORE_SELECTED_CATEGORY_IDS](state: RootState) {
    return state.course.explore.selectedCategoryIds;
  },
  [COURSE_EXPLORE_SELECTED_EXAM_INDEX](state: RootState) {
    return state.course.explore.selectedExamIndex;
  },
  [COURSE_EXPLORE_SELECTED_LEVEL_INDEXES](state: RootState) {
    return state.course.explore.selectedLevelIndexes;
  },
  [FLAT_EXERCISE_LIST](state: any) {
    return (payload: { courseUuid?: string; assignmentId?: string }) => {
      let exerciseList;

      if (state.terratalkLive.limitedModeDetails) {
        return state.terratalkLive.limitedModeDetails.exercises;
      } else if (payload.assignmentId) {
        exerciseList = state.assignment.details;
      } else {
        exerciseList = state.content.course.details;
      }

      return flattenCourseExercises(exerciseList);
    };
  },
  [GROUP_COURSE_LIMIT_MULTIPLIER](state: RootState) {
    return state.course.group.limitMultiplier;
  },
  [GROUP_COURSE_SELECTED_CATEGORY_IDS](state: RootState) {
    return state.course.group.selectedCategoryIds;
  },
  [GROUP_COURSE_SELECTED_EXAM_INDEX](state: RootState) {
    return state.course.group.selectedExamIndex;
  },
  [GROUP_COURSE_SELECTED_GROUP_INDEX](state: RootState) {
    return state.course.group.selectedGroupIndex;
  },
  [GROUP_COURSE_SELECTED_LEVEL_INDEXES](state: RootState) {
    return state.course.group.selectedLevelIndexes;
  },
  [OPENED_CHAPTERS](state: RootState, _, __, rootGetters) {
    const aliasUuid = rootGetters?.auth_info?.aliasUuid;

    return state.course?.openedChapters[aliasUuid] || {};
  },
  [LEARNING_HISTORY_END_DATE](state: RootState) {
    return state.historyInputs.endDate;
  },
  [LEARNING_HISTORY_START_DATE](state: RootState) {
    return state.historyInputs.startDate;
  },
  [LEARNING_HISTORY_SELECTED_EXERCISE_TYPE_AND_SKILL](state: RootState) {
    return state.historyInputs.selectedExerciseTypeAndSkill;
  },
  [PREVIOUS_ROUTE](state: RootState) {
    return state.navigation.prevPath;
  },

  [SELECTED_SKILL_LEVEL_INDEXES](state: RootState) {
    const userUuid = ((state as any).user as UserState).profile?.userUuid || "";

    return state.skills.selectedSkillLevelIndexes[userUuid];
  }
};
